import { AccountConnectorService } from '../configuration';
import { open as openPopup } from '../popup';
import request, { endpoint } from './request';

export function authConnector(
  service: AccountConnectorService,
  successCallback: (data: any) => void,
  errorCallback: (data: any) => void,
) {
  openPopup(`${endpoint}/auth/${service}`);

  const onMessageFunc = (event: MessageEvent) => {
    if (event.data.type === 'clearbitAuthComplete' && successCallback) {
      successCallback(event.data);
    } else if (event.data.type === 'clearbitAuthError' && errorCallback) {
      errorCallback(event.data);
    }

    window.removeEventListener('message', onMessageFunc, false);
  };

  window.onmessage = onMessageFunc;
}

export function getCurrentUser() {
  return request({
    path: '/v1/users/current',
  });
}

export function getCurrentAccount() {
  return request({
    path: '/v1/accounts/current',
  });
}

export function isAuthRoute() {
  return window.location.pathname.startsWith('/auth/');
}

export function authUser() {
  if (isAuthRoute()) return;

  if (window.localStorage.getItem('USE_STYTCH_AUTH') === 'true') {
    window.location.pathname = '/auth/login';
    return;
  }

  window.location.pathname = '/auth';
}

export function logoutUser() {
  window.location.pathname = '/logout';
}
